module.exports = __webpack_public_path__ + "img/Schlauchwagen.d59a9705.svg";